import { Component, OnInit, ViewChild } from '@angular/core';
import { MCPlanningMaterialService } from '../../Services/MCPlanningMaterial/mcplanningmaterial.service';
import { MatSnackBarComponent } from '../mat-snack-bar/mat-snack-bar.component';
import { MaterialDispatchDetails, UserDetails, Documents } from '../../Models/Material-Dispatch/MaterialDispatch'
import { DatePipe } from '@angular/common';
import { Response } from '@angular/http';
import { Validators } from '@angular/forms';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { MaterialAllocationFilter, userID} from '../../Models/MaterialAllocation/MaterialAllocation'
import { saveAs } from 'file-saver';
import { Router } from '@angular/router';
import { Alert } from 'selenium-webdriver';
import { ToastrModule, ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-material-dispatch',
  templateUrl: './material-dispatch.component.html',
  styleUrls: ['./material-dispatch.component.css'],
  providers: [DatePipe]
})
export class MaterialDispatchComponent implements OnInit {

  @ViewChild('requirementStatus') requirementStatus;
  @ViewChild('JobNumber') JobNumber;
  @ViewChild('State') State;
  @ViewChild('JobType') JobType
  @ViewChild('Brand') Brand
  @ViewChild('Crops') Crops
  @ViewChild('Languages') Languages
  @ViewChild('RMHName') RMHName
  @ViewChild('year') year;
  userID: string;
  roleID: string;
  Status: string;
  loader: string;
  materialDispatchDetails: MaterialDispatchDetails[] = [];
  viewMaterialDispatchDetails: MaterialDispatchDetails = new MaterialDispatchDetails();
  UserDetails: UserDetails[] = [];// new UserDetails();
  NewUserDetails: UserDetails[] = [];
  materialDispatchFilters: MaterialAllocationFilter = new MaterialAllocationFilter();

  displayAddDispatchDetailPanel: string = 'none;'
  displayStatusPanel: string = 'none';
  viewDatetext: any;
  dispatchDate: any;
  estimatedDeliveryDate: any;

  selectCheck: boolean = false;
  requirementId: string = '';
  additionalrequirementId: string = '';
  selectStatus: number;

  selectedRMHName: string = '';
  selectedJobType: string = '';
  selectedBrand: string = '';
  selectedCrop: string = '';
  selectedLanguage: string = '';
  selectedJobNumber: string;
  selectedState: string;
  selectedYear: string = '';
  ascNumberSort: boolean = true;
  sortDirection: string = '';

  dropdownMonth = [];
  selectedItems = [];
  dropdownStatus = [];
  dropdownCropSettings: IDropdownSettings = {};
  dropdownBrandSettings: IDropdownSettings = {};
  dropdownJobTypeSettings: IDropdownSettings = {};
  dropdownLanguageSettings: IDropdownSettings = {};
  dropdownRmhsSettings: IDropdownSettings = {};
  dropdownstatusSettings: IDropdownSettings = {};
  dropdownJobNumbersSetting: IDropdownSettings = {};
  dropdownstateSetting: IDropdownSettings = {};
  indexCount:number;
  yearSettings: IDropdownSettings={};
  files: File[] = [];
  IsFileCorrect: boolean;
  @ViewChild('file') input;
  document: Documents = new Documents();

  popJobNumber:any;
  popUserName:any;
  popUserID:any;
  popDesgnation:any;
  popAllocatedQty:number;
  popMobileNumber:number;
  popTransportname:any;
  popDispatchDate:Date;
  popDispatchLocation:any;
  popDispatchAddress:any;
  popnoofBoxes:number;
  popQuantityDispatch:number;
  popExpectedDelivery:Date;
  popRemarks:any;
  dispatchDone:boolean;
  displayViewPanel:string;
  displayEditPanel:string;
  popRegion:string;
  popPOQty:number;
  popRemainingQty:any;

  constructor(private mcPlanningMaterialService: MCPlanningMaterialService, private snackBar: MatSnackBarComponent, private datePipe: DatePipe,
    private toastr: ToastrService,
    private router: Router) {
    this.roleID = localStorage.getItem('mcmt_roleID');
    this.userID = localStorage.getItem('mcmt_userId');

  }

  ngOnInit() {
    if (sessionStorage.tabID == undefined) {
      this.router.navigate(['/MCMaterial/Login']);
    }
    this.MaterialDispatchfilter();
    this.bindDropdown();
    
    this.displayAddDispatchDetailPanel = 'none';
  }
  getMaterialDispatchDetails() {
    this.selectedRMHName = Array.prototype.map.call(this.RMHName.selectedItems, function (item) { return item.id }).join(",");
    this.selectedCrop = Array.prototype.map.call(this.Crops.selectedItems, function (item) { return item.id; }).join(",");
    this.selectedBrand = Array.prototype.map.call(this.Brand.selectedItems, function (item) { return item.id }).join(",");
    this.selectedLanguage = Array.prototype.map.call(this.Languages.selectedItems, function (item) { return item.id; }).join(",");
    this.selectedJobType = Array.prototype.map.call(this.JobType.selectedItems, function (item) { return item.id; }).join(",");
    this.selectedJobNumber = Array.prototype.map.call(this.JobNumber.selectedItems, function (item) { return item.id; }).join(",");
    this.selectedState = Array.prototype.map.call(this.State.selectedItems, function (item) { return item.id; }).join(",");
    this.Status = Array.prototype.map.call(this.requirementStatus.selectedItems, function (item) { return item.text; }).join(",");
    this.selectedYear = Array.prototype.map.call(this.year.selectedItems, function (item) { return item.text; }).join(",");
    if (this.Status.length == 0)
      this.Status = Array.prototype.map.call(this.dropdownStatus,function(item){return item.item_text; }).join(",");//'10,11,12'
    this.mcPlanningMaterialService.GetMaterialDispatchToField(this.selectedRMHName, this.selectedJobType, this.selectedBrand, this.selectedCrop, this.selectedLanguage, this.Status, this.selectedJobNumber, this.selectedState, this.selectedYear)
      .subscribe((responseData: any) => {
        if (responseData.status) {
          debugger;
          this.materialDispatchDetails = responseData.data;
          this.loader = 'none';
        }
        else {
          this.materialDispatchDetails = null;
          // this.toastr.error('No records available', 'Close', 'red-snackbar');
          this.loader = 'none';
        }
      })
  }

  onItemSelect(event: any, filter: string) {
  }
  onSelectAll(event: any, filter: string) {
  }
  deSelectAll(event: any, filter: string) {
  }
  unSelect(event: any, filter: string) {
  }
  bindDropdown() {
    this.dropdownCropSettings = {
      singleSelection: false,
      idField: 'cropID',
      textField: 'cropName',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 2,
      allowSearchFilter: true,
      enableCheckAll: true
    };
    this.yearSettings = {
      singleSelection: true,
      idField: 'year',
      textField: 'year',
      enableCheckAll: false,
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: false,
      limitSelection: -1,
      clearSearchFilter: false,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Year Found',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
    this.dropdownBrandSettings = {
      singleSelection: false,
      idField: 'brandName',
      textField: 'brandName',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 2,
      allowSearchFilter: true,
      enableCheckAll: true

    };
    this.dropdownJobTypeSettings = {
      singleSelection: false,
      idField: 'jobTypeID',
      textField: 'jobTypeName',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 2,
      allowSearchFilter: true,
      enableCheckAll: true

    };
    this.dropdownLanguageSettings = {
      singleSelection: false,
      idField: 'languageID',
      textField: 'languageName',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 2,
      allowSearchFilter: true,
      enableCheckAll: true

    };
    this.dropdownRmhsSettings = {
      singleSelection: false,
      idField: 'rMHCode',
      textField: 'rMHName',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 2,
      allowSearchFilter: true,
      enableCheckAll: true
    };
    this.dropdownJobNumbersSetting = {
      singleSelection: false,
      idField: 'jobNumber',
      textField: 'jobNumber',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 2,
      allowSearchFilter: true,
      enableCheckAll: true
    };
    this.dropdownstateSetting = {
      singleSelection: false,
      idField: 'stateID',
      textField: 'stateName',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: true,
      enableCheckAll: true
    };
    this.dropdownStatus = [
      { item_id: 10, item_text: 'Dispatch To Field In Process' },
      { item_id: 11, item_text: 'Field Team Confirmation Pending' },
      { item_id: 12, item_text: 'Received by Field team' }
    ];

    this.dropdownstatusSettings = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: true,
      enableCheckAll: true
    }
    this.dropdownMonth = [
      { item_id: 1, item_text: 'January' },
      { item_id: 2, item_text: 'February' },
      { item_id: 3, item_text: 'March' },
      { item_id: 4, item_text: 'April' },
      { item_id: 5, item_text: 'May' },
      { item_id: 6, item_text: 'June' },
      { item_id: 7, item_text: 'July' },
      { item_id: 8, item_text: 'August' },
      { item_id: 9, item_text: 'September' },
      { item_id: 10, item_text: 'October' },
      { item_id: 11, item_text: 'November' },
      { item_id: 12, item_text: 'December' }
    ];
  }
  filesDroppedAdd(files: File[]) {
    this.loader = 'block';
    this.files = [];
    this.files = files;
    let fileNameParts: string[] = files[0].name.split('.');
    let fileType = files[0].name.split('.')[fileNameParts.length - 1];
    let Name = localStorage.getItem('mcmt_userName').split(' ');
    let Firstname = Name[0];
    let LastName = Name[1];
    // let CorrectFileName = Firstname + '_' + LastName + '_MaterialDispatch_'
    // if (fileNameParts[0].includes(CorrectFileName)) {
    //   this.IsFileCorrect = true;
    // }
    // else {
    //   this.IsFileCorrect = false;
    // }
    if (this.IsFileCorrect == false) {
      this.toastr.error('Please select a valid file.');
      this.loader = 'none';
      this.input.nativeElement.value = null;
      return false;
    }
    if (fileType != 'xls' && fileType != 'xlsx') {
      this.toastr.error('Please select valid file type.');
      this.loader = 'none';
      this.input.nativeElement.value = null;
      return false;
    }

    //this.loader = 'block';
    this.document.file = <File>this.files[0];
    //this.document.UploadedBy = localStorage.getItem('userId');
    this.mcPlanningMaterialService.uploadMaterialDispatchDocument(this.document.file)
      .subscribe((resData: any) => {
        if (resData.status == true) {
          this.toastr.success(resData.message);
          //this.loader = 'none';
          this.getMaterialDispatchDetails();
          //this.getsaveSubmitStatus() ;
        } else {
          this.toastr.error(resData.message);
          //this.loader = 'none';
          this.getMaterialDispatchDetails();
          //this.getsaveSubmitStatus() ;
        }
        this.files = [];
        this.input.nativeElement.value = null;
        this.loader = 'none';
      });
    this.files = files;
  }

  MaterialDispatchfilter() {
    this.loader = 'block';
    this.mcPlanningMaterialService.getMaterialDispatchFilter()
      .subscribe((responsedata: any) => {
        if (responsedata.status == true) {
          this.materialDispatchFilters = responsedata.data;
          this.materialDispatchFilters.year = responsedata.data.currentRequirementYear;
          class YearItemList{
            id: string;
            text: string;
        }
          let requiredItem: YearItemList[] = [];
          var obj = {
            id : this.materialDispatchFilters.year[0].currentrequirementYear,
            text: this.materialDispatchFilters.year[0].currentrequirementYear
          }
          requiredItem.push(obj)
          this.year.selectedItems = requiredItem;
          this.loader = 'none';
          this.getMaterialDispatchDetails();
        }
        else {
          this.toastr.error('No data available in filters');
          this.loader = 'none';
        }
      })
  }

  onYearSelect(item: any) {
    let selectedyear = this.year.selectedItems[0].id;
    
    if(selectedyear != this.materialDispatchFilters.year[0].currentrequirementYear)
    {     
      var someElement= document.getElementById("ancUploadExcel"); 
      someElement.className += "hideuploadExcel";
    }
    else
    {
      document.getElementById("ancUploadExcel").classList.remove("hideuploadExcel");
    }
  }

  GetUserDetails() {
    this.mcPlanningMaterialService.GetUserDetails(this.viewMaterialDispatchDetails.requirementDetailID, this.viewMaterialDispatchDetails.jobNumber, this.viewMaterialDispatchDetails.requirementType)
      .subscribe((responseData: any) => {
        if (responseData.status) {
          this.UserDetails = responseData.data; 
          var _data = this.UserDetails;
          debugger;
          
          // var unique = [];
          // var distinct = [];
          
          // for( let i = 0; i < _data.length; i++ ){
          //   if( !unique[_data[i].userID] && !unique[_data[i].regioncode]){
          //     distinct.push(_data[i]);
          //     unique["userID"] = 1;
          //     unique["regioncode"] = 1;
          //   }
          // }

          const distinctThings = _data.filter((thing, i, arr) => {
            return arr.indexOf(arr.find(t => t.userID === thing.userID && t.regioncode === thing.regioncode)) === i;
          });
          
          this.NewUserDetails = distinctThings;
  
          this.popUserName=this.UserDetails.length>0?this.UserDetails[0].userName+"#"+this.UserDetails[0].requirementDetailID+"#"+this.UserDetails[0].userID:null;
          //this.popUserName=this.UserDetails.length>0?this.UserDetails[0].userName:null; //Added for Getting 1st MIE/MDO As Default Selection
          this.popUserID=this.UserDetails.length>0?this.UserDetails[0].userID:null; //Added for Getting 1st MIE/MDO As Default Selection
          this.popDesgnation=this.UserDetails.length>0?this.UserDetails[0].userRole:null; //Added for Getting 1st MIE/MDO As Default Selection
          this.popAllocatedQty=this.UserDetails.length>0?this.UserDetails[0].allocatedQuantity:0;
          this.popMobileNumber=this.UserDetails.length>0?this.UserDetails[0].mobileNumber:null;
          this.popQuantityDispatch=this.UserDetails.length>0?this.UserDetails[0].allocatedQuantity:0;
          this.dispatchDone=this.UserDetails.length>0 && this.UserDetails[0].dispatchDate!=null?true:false;
          this.popRegion=this.UserDetails.length>0?this.UserDetails[0].regioncode:null;
          this.popPOQty=this.UserDetails.length>0?this.UserDetails[0].poIssuedQuantity:0;
          this.popRemainingQty=this.UserDetails.length>0?this.UserDetails[0].availableInInventory:'0';
          
          this.popnoofBoxes=0;
          this.loader = 'none';
        }
        else {
          this.UserDetails = responseData.data;
          this.toastr.error('No MIE/MDO User available');
          this.loader = 'none';
          this.displayAddDispatchDetailPanel='none';
        }
      })
     
  }
  ViewMaterialDispatch(index: number) {
    debugger;
    this.indexCount=index;
    this.viewMaterialDispatchDetails = new MaterialDispatchDetails();
    this.displayAddDispatchDetailPanel = 'block';
    this.viewMaterialDispatchDetails = this.materialDispatchDetails[index];
    this.popJobNumber=this.materialDispatchDetails[index].jobNumber;
    this.popRemainingQty=this.materialDispatchDetails[index].availableInInventory==null?'0':this.materialDispatchDetails[index].availableInInventory;    
    let allocationDone = false;
    allocationDone = this.materialDispatchDetails[index].materialAllocationDone;
    this.displayEditPanel='block';
    this.displayViewPanel='block'
    this.GetUserDetails();
    if (this.viewMaterialDispatchDetails.dispatchDate == null)
      this.viewDatetext = null;
    else {
      if (this.viewDatetext == null) {
        //  this.UserDetails[index].dispatchDate = this.datePipe.transform(this.viewMaterialDispatchDetails.dispatchDate, 'dd-MM-yyyy');
        //   this.UserDetails[index].estimatedDeliveryDate  = this.datePipe.transform(this.viewMaterialDispatchDetails.estimatedDeliveryDate, 'dd-MM-yyyy');
      }
      this.viewDatetext = 1;
    }
    // this.UserDetails.forEach(element => {
    //   element.estimatedDeliveryDate=this.datePipe.transform(element.estimatedDeliveryDate, 'dd-MM-yyyy');
    // });

    const body = document. getElementsByTagName('body')[0];
    body.classList.add('overlay-back');

  }
  // SaveMaterialDispatchDetails(index: number) {
  //   this.loader = 'block';
  //   this.UserDetails[index].statusID = 11;
  //   if (this.UserDetails[index].allocatedQuantity >= this.UserDetails[index].quantityDispatched) {
  //     if (this.validateMobileNumber(this.UserDetails[index].mobileNumber)) {
  //       if (this.UserDetails[index].quantityDispatched != null && this.UserDetails[index].quantityDispatched != 0) {
  //         if (this.UserDetails[index].transportName != null && this.UserDetails[index].dispatchDate != null && this.UserDetails[index].estimatedDeliveryDate!=null) { 
  //           // if (this.UserDetails[index].totalRemaining == 0)
  //           // {
  //           this.mcPlanningMaterialService.SaveDispatchDetails(this.UserDetails[index])
  //             .subscribe((responseData: any) => {
  //               if (responseData.status) {

  //                 this.displayAddDispatchDetailPanel = 'none';
  //                 this.loader = 'none';
  //                 this.toastr.error('Records Saved Successfully', 'Close', 'green-snackbar');
  //                 //this.getMaterialDispatchDetails();
  //                 this.ViewMaterialDispatch(this.indexCount);
  //               }                                                        
  //                 else{
  //                 this.toastr.error('Error in saving records', 'Close', 'red-snackbar');
  //                 this.loader = 'none';
  //                 this.ViewMaterialDispatch(this.indexCount);
  //                 }              
  //             })
  //         // }
  //         // else{
  //         //   this.toastr.error('Job number have remaining value to Allocate', 'Close', 'red-snackbar');
  //         //   this.loader = 'none';
  //         // }
  //       }       
  //         else {
  //           this.toastr.error('Please enter required inputs', 'Close', 'red-snackbar');
  //         }
  //       }
  //       else {
  //         this.toastr.error('Invalid Dispatched Quantity', 'Close', 'red-snackbar');
  //       }
  //     }
  //     else {
  //       this.toastr.error('Please enter a Valid Mobile Number', 'Close', 'red-snackbar');
  //     }
  //   }
  //   else {
  //     this.toastr.error('Dispatch Quantity can not exceed Allocated Quantity', 'Close', 'red-snackbar');
  //    // this.toastr.error('Quantity dispatch should be equal to Allocate Quantity', 'Close', 'red-snackbar');
  //   }

  // }
  SaveMaterialDispatchDetails() {
    this.loader = 'block';
    let popUpName=this.popUserName.split("#");
    let index=this.UserDetails.indexOf(this.UserDetails.find(m => m.userName == popUpName[0] && m.requirementDetailID == popUpName[1] && m.userID == popUpName[2]));
    this.UserDetails[index].statusID = 11;
    this.UserDetails[index].mobileNumber=this.popMobileNumber;
    this.UserDetails[index].noOfBoxes=this.popnoofBoxes;
    this.UserDetails[index].quantityDispatched=this.popQuantityDispatch;
    this.UserDetails[index].dispatchAddress=this.popDispatchAddress;
    this.UserDetails[index].dispatchDate=this.popDispatchDate;
    this.UserDetails[index].dispatchLocation=this.popDispatchLocation;
    this.UserDetails[index].transportName=this.popTransportname;
    this.UserDetails[index].userID=this.popUserID;
    this.UserDetails[index].userRole=this.popDesgnation;
    // this.UserDetails[index].userName=this.popUserName;
    this.UserDetails[index].userName=popUpName[0];
    this.UserDetails[index].estimatedDeliveryDate=this.popExpectedDelivery;
    this.UserDetails[index].remarks=this.popRemarks;

    if (this.UserDetails[index].dispatchDate > this.UserDetails[index].estimatedDeliveryDate) {
      this.toastr.error('Dispatch Date Should Not Be Greater Than Estimated Delivery Date  .');
      this.loader = 'none';
      return false;
    }


   // if (this.UserDetails[index].allocatedQuantity >= this.UserDetails[index].quantityDispatched) {
      if (this.validateMobileNumber(this.UserDetails[index].mobileNumber)) {
        if (this.UserDetails[index].quantityDispatched != null && this.UserDetails[index].quantityDispatched != 0 && this.UserDetails[index].quantityDispatched<=this.popPOQty ) {
          if (this.UserDetails[index].transportName != null && this.UserDetails[index].dispatchDate != null && this.UserDetails[index].estimatedDeliveryDate!=null) { 
            // if (this.UserDetails[index].totalRemaining == 0)
            // {
            this.mcPlanningMaterialService.SaveDispatchDetails(this.UserDetails[index])
              .subscribe((responseData: any) => {
                if (responseData.status) {
                  if(responseData.message=='Requested Qty Not available in Inventory')
                  {
                    this.displayAddDispatchDetailPanel = 'none';
                    this.loader = 'none';
                    this.toastr.error('Requested Qty Not available in Inventory ');
                  }
                  else if(responseData.message=='Incorrect Dispatch Quantity. Dispatch Quantity greater than Total Remaining Quantity.')
                  {
                    this.displayAddDispatchDetailPanel = 'none';
                    this.loader = 'none';
                    this.toastr.error('Incorrect Dispatch Quantity. Dispatch Quantity greater than Total Remaining Quantity.');
                  }
                  else if(responseData.message=='Incorrect Dispatch Quantity. Dispatch Quantity greater than Approved Quantity For This Region.')
                  {
                    this.displayAddDispatchDetailPanel = 'none';
                    this.loader = 'none';
                    this.toastr.error('Incorrect Dispatch Quantity. Dispatch Quantity greater than Approved Quantity For This Region.');
                  }
                  else
                  {
                  this.displayAddDispatchDetailPanel = 'none';
                  this.loader = 'none';
                  this.toastr.success('Records Saved Successfully');
                  this.getMaterialDispatchDetails();
                  //this.ViewMaterialDispatch(this.indexCount);
                }
                }                                                        
                  else{
                  this.toastr.error('Error in saving records');
                  this.loader = 'none';
                  this.ViewMaterialDispatch(this.indexCount);
                  }              
              })
          // }
          // else{
          //   this.toastr.error('Job number have remaining value to Allocate', 'Close', 'red-snackbar');
          //   this.loader = 'none';
          // }
        }       
          else {
            this.loader = 'none';
            this.toastr.error('Please enter required inputs');
          
          }
        }
        else {
          this.loader = 'none';
          this.toastr.error('Invalid Dispatched Quantity');
        }
      }
      else {
        this.loader = 'none';
        this.toastr.error('Please enter a Valid Mobile Number');
      }
    // }
    // else {
    //   this.toastr.error('Dispatch Quantity can not exceed Allocated Quantity', 'Close', 'red-snackbar');
    //  // this.toastr.error('Quantity dispatch should be equal to Allocate Quantity', 'Close', 'red-snackbar');
    // }

  }
  closePanel() {
    this.displayAddDispatchDetailPanel = 'none';
    this.getMaterialDispatchDetails();
    const body = document. getElementsByTagName('body')[0];
    body.classList.remove('overlay-back');
  }
  DownloadMaterialDispatchExcel() {
    this.loader = 'block';
    this.selectedYear = Array.prototype.map.call(this.year.selectedItems, function (item) { return item.id; }).join(",");
  //  this.Status = Array.prototype.map.call(this.dropdownStatus,function(item){return item.item_text; }).join(",");//'10,11,12'
    this.mcPlanningMaterialService.DownloadMaterialDispatchExcel(this.Status,this.selectedYear)
      .subscribe(
        success => {
          var date = new Date();
          var latest_date = this.datePipe.transform(date, 'dd-MMM-yy');
          var Name = localStorage.getItem('mcmt_userName').split(' ');
          var Firstname = Name[0];
          var LastName = Name[1];
          let cYear = this.year.selectedItems[0].id;
          var ExcelName = Firstname + '_' + LastName + '_'+ cYear + '_MaterialDispatch_' + latest_date + '.xlsx';
          //let roleId=localStorage.getItem('mcmt_roleID');
          if (success.size > 0)
            saveAs(success, ExcelName);
          else
            this.toastr.error("No Records available for Excel.");
          this.loader = 'none';
        },
        err => {
          this.toastr.error("Some problem occurred while downloading file.");
          this.loader = 'none';
          console.log(err);
        }
      );
  }
  CheckNumber(event: any) {
    if (Number(event.currentTarget.value) < 0)
      event.currentTarget.value = "0";
  }
  validateMobileNumber(mobilenumber: any): boolean {
    if (isNaN(Number(mobilenumber)) || mobilenumber.length != 10) {
      return false;
    }
    return true;
  }
  // SelectAll() {
  //   this.materialDispatchDetails.forEach(element => {
  //     if (this.selectCheck == true)
  //     {
  //       if(element.isConfirmReceipt)
  //       element.isSelected = true;
  //     }
  //     else {
  //       element.isSelected = false;
  //       this.requirementId = "";
  //     }
  //   })
  // }

  // checkSelected(index: number) {
  //   if (!this.materialDispatchDetails[index]["isSelected"]) {
  //     if(this.materialDispatchDetails[index]["requirementType"]==1)
  //     {
  //       if(this.materialDispatchDetails[index]["isConfirmReceipt"])
  //       this.requirementId.trim().replace(this.materialDispatchDetails[index]["requirementDetailID"] + ',', '');
  //      }
  //     else
  //     {
  //       if(this.materialDispatchDetails[index]["isConfirmReceipt"])
  //       this.additionalrequirementId.trim().replace(this.materialDispatchDetails[index]["requirementDetailID"] + ',', '');
  //     }  
  //     this.selectCheck = false;
  //   }
  // }
  // GetcheckedItem() {
  //   this.materialDispatchDetails.forEach(element => {
  //     if (this.selectCheck == false)
  //     {
  //       if(element.requirementType==1)
  //       this.requirementId += element.isSelected == undefined || element.isSelected == false ? "" : element.requirementDetailID + ",";
  //       else
  //       this.additionalrequirementId+= element.isSelected == undefined || element.isSelected == false ? "" : element.requirementDetailID + ",";
  //     }
  //     else
  //       if(element.requirementType==1)
  //       this.requirementId += element.requirementDetailID + ",";
  //       else
  //       this.additionalrequirementId+=  element.requirementDetailID + ",";
  //   });
  //   if (this.requirementId.trim().length > 0 || this.additionalrequirementId.trim().length > 0)
  //   {
  //   this.selectStatus=13;
  //     this.displayStatusPanel = 'block';
  //   }
  // }

  submitStatus() {
    this.mcPlanningMaterialService.UpdateMaterialDispatchStatus(this.requirementId, this.selectStatus, this.additionalrequirementId)
      .subscribe((responseData: any) => {
        if (responseData.status) {
          this.toastr.success('Status Updated Successfully');
          this.loader = 'none';
          this.displayStatusPanel = 'none';
          this.getMaterialDispatchDetails();
        }
        else {
          this.toastr.error('Some error Occured,Could not update status');
          this.loader = 'none';
          this.displayStatusPanel = 'none';
        }
      })
  }
  closeStatusPanel() {
    this.displayStatusPanel = 'none';
    this.requirementId = '';
    this.additionalrequirementId = '';
  }

  changeStatus(details: any) {
    if (details.requirementType == "1")
      this.requirementId = details.requirementDetailID;
    else
      this.additionalrequirementId = details.requirementDetailID;

    this.selectStatus = details.statusID;
    this.submitStatus();
  }

  sort() {
    let sortedArray : any[] = [];
    let splitString : any[] = [];
    if (this.ascNumberSort == true) {
      this.dropdownMonth.forEach(x => {
        this.materialDispatchDetails.forEach(element => {
          splitString = element.month.split("'");
          if (x.item_text.substring(0,3) == splitString[0]) {
            sortedArray.push(element);
          }
        })
      })
      this.ascNumberSort = false;
      this.sortDirection = 'asc';
      this.materialDispatchDetails = sortedArray;
    }
    else {
      this.dropdownMonth.forEach(x => {
        this.materialDispatchDetails.forEach(element => {
          splitString = element.month.split("'");
          if (x.item_text.substring(0,3) == splitString[0]) {
            sortedArray.push(element);
          }
        })
      })
      this.ascNumberSort = true;
      this.sortDirection = 'desc';
      this.materialDispatchDetails = sortedArray.reverse();
    }
  }

  changeName(details: any) {
    let popUpdetail=this.popUserName.split("#");
    this.popDesgnation = details.find(m => m.userName == popUpdetail[0] && m.requirementDetailID == popUpdetail[1] && m.userID == popUpdetail[2]).userRole;
    this.popUserID = details.find(m => m.userName == popUpdetail[0] && m.requirementDetailID == popUpdetail[1] && m.userID == popUpdetail[2]).userID;
    this.popAllocatedQty=details.find(m => m.userName == popUpdetail[0] && m.requirementDetailID == popUpdetail[1] && m.userID == popUpdetail[2]).allocatedQuantity;
    this.popDispatchDate=details.find(m => m.userName == popUpdetail[0] && m.requirementDetailID == popUpdetail[1] && m.userID == popUpdetail[2]).dispatchDate;
    this.popDispatchAddress=details.find(m => m.userName == popUpdetail[0] && m.requirementDetailID == popUpdetail[1] && m.userID == popUpdetail[2]).dispatchAddress;
  this.popDispatchLocation=details.find(m => m.userName == popUpdetail[0] && m.requirementDetailID == popUpdetail[1] && m.userID == popUpdetail[2]).dispatchLocation;
  this.popExpectedDelivery=details.find(m => m.userName == popUpdetail[0] && m.requirementDetailID == popUpdetail[1] && m.userID == popUpdetail[2]).estimatedDeliveryDate;
  this.popMobileNumber=details.find(m => m.userName == popUpdetail[0] && m.requirementDetailID == popUpdetail[1] && m.userID == popUpdetail[2]).mobileNumber;
  this.popTransportname=details.find(m => m.userName == popUpdetail[0] && m.requirementDetailID == popUpdetail[1] && m.userID == popUpdetail[2]).transportName;
  this.popQuantityDispatch=details.find(m => m.userName == popUpdetail[0] && m.requirementDetailID == popUpdetail[1] && m.userID == popUpdetail[2]).quantityDispatched;
  this.popRemarks=details.find(m => m.userName == popUpdetail[0] && m.requirementDetailID == popUpdetail[1] && m.userID == popUpdetail[2]).remarks;
  this.popnoofBoxes=details.find(m => m.userName == popUpdetail[0] && m.requirementDetailID == popUpdetail[1] && m.userID == popUpdetail[2]).noOfBoxes;
  this.dispatchDone=details.find(m => m.userName == popUpdetail[0] && m.requirementDetailID == popUpdetail[1] && m.userID == popUpdetail[2]).dispatchDate?true:false;
  this.popRegion=details.find(m => m.userName == popUpdetail[0] && m.requirementDetailID == popUpdetail[1] && m.userID == popUpdetail[2]).regioncode;
  //this.popRegion=details.find(m => m.userName == popUpdetail[0] && m.requirementDetailID == popUpdetail[1]).regioncode;
}
ShowMaterialDispatch(index:number)
{
  this.indexCount=index;
    this.viewMaterialDispatchDetails = new MaterialDispatchDetails();
    this.displayAddDispatchDetailPanel = 'block';
    this.viewMaterialDispatchDetails = this.materialDispatchDetails[index];
  this.displayAddDispatchDetailPanel = 'block';
  this.GetUserDetails();
  this.displayEditPanel='none';
  this.displayViewPanel='block';
}

ConvertToCurrency(value:any)
  {
    var parts = value.toString().replace(',','').split(".");
    if(parts[0].length > 3){
      parts[0] = parts[0].slice(0,parts[0].length-3).replace(/\B(?=(\d{2})+(?!\d))/g, ",") +','+ parts[0].slice(parts[0].length-3,parts[0].length);
    }
    return parts.join(".");
  }
}
